<template>
  <div class="ctotal bgps flex" @mouseleave="mouseLeave">
    <div
      v-for="(i, j) in titlearr"
      :key="j"
      class="f1 flex  ac jc"
      @click="tabclick(j,i)"
      @mouseenter="mouseEnter(i)"
      
      :style="`color:${ i.select == value ? 'white' : ''}; backgroundImage:${ i.select == value ? `url(${src})` : ''}`"
    >
      {{ i.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titlearr:{
      default:[{ label: "项目概况", select: 1 },
      { label: "参建单位", select: 0 },
      { label: "施工管理人员", select: 0 } ]
    },
    active:{
      type:String
    }
  },
  data() {
    return {
      src: require("../../assets/image/按钮效果.png"),
      value:this.active,
      oldValue:this.active
    };
  },
  methods: {
    tabclick(e,i) {
      this.$emit('tabnum1',e,i)
      this.$emit('tabnum2',e)
      this.value =i.select
      this.oldValue = i.select
    },
    mouseEnter(i){
      this.value = i.select
      console.log(i,'鼠标移入')
    },
    mouseLeave(){
      console.log('鼠标移出')
      this.value = this.oldValue
    }    
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.ctotal {
  cursor: pointer;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  background: url("../../assets/image/标题背景-短.png") no-repeat;
  >div{
    background-size: 100% 100%;
  background-position: 0 0;
  }
}
</style>
